import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faMapMarkerAlt, faPhone, faTruckFast } from '@fortawesome/free-solid-svg-icons';

const hours = [
  ['Mon', '9:00am - 5:30pm'],
  ['Tue', '9:00am - 5:30pm'],
  ['Wed', '9:00am - 5:30pm'],
  ['Thu', '9:00am - 5:30pm'],
  ['Fri', '9:00am - 5:30pm'],
  ['Sat', '9:00am - 5:30pm'],
  ['Sun', '10:00am - 4:00pm']
];

const Contact = () => (
  <div className="content-page contact-2026">
    <section className="page-hero contact-hero">
      <div className="page-hero-copy">
        <p className="eyebrow">Contact Game On</p>
        <h1>Trade in, collect, upgrade or ask us what your tech is worth.</h1>
        <p>
          Pop into the shop on Cosham High Street, call ahead, or use the map below to find us.
        </p>
        <div className="contact-actions">
          <a className="btn-red" href="tel:02392383313">Call 02392 383 313</a>
          <a className="btn-ghost" href="https://www.google.com/maps/search/?api=1&query=Game%20On%20Cosham" target="_blank" rel="noopener noreferrer">
            Open map
          </a>
        </div>
      </div>
      <aside className="contact-panel">
        <h2>Shop details</h2>
        <p><FontAwesomeIcon icon={faMapMarkerAlt} /> 1-2 Crown Buildings, Cosham, Portsmouth, PO6 3BU</p>
        <p><FontAwesomeIcon icon={faPhone} /> 02392 383 313</p>
        <p><FontAwesomeIcon icon={faTruckFast} /> Free local collection</p>
      </aside>
    </section>

    <section className="contact-grid-section">
      <div className="map-panel">
        <iframe
          title="Map showing Game On Cosham"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5038.387643746005!2d-1.066484!3d50.846095!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487442d6081f1279%3A0xcf3c179d6250858f!2sGame%20On!5e0!3m2!1sen!2suk!4v1755074632971!5m2!1sen!2suk"
          loading="lazy"
          allowFullScreen=""
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      <div className="hours-panel">
        <p className="eyebrow"><FontAwesomeIcon icon={faClock} /> Opening hours</p>
        <h2>Open every week.</h2>
        <dl>
          {hours.map(([day, time]) => (
            <div key={day}>
              <dt>{day}</dt>
              <dd>{time}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  </div>
);

export default Contact;
